import {Collapse} from '@ds/components';

import {FAQ_ITEMS} from './constants';

const Faq: React.FC = () => {
  return (
    <div className="overflow-y-auto">
      <Collapse
        bordered={false}
        className="bg-white [&>div+div]:border-t [&>div+div]:border-disabled-border"
        items={FAQ_ITEMS.map((item, index) => ({
          key: String(index),
          label: (
            <span className="flex min-h-12 items-center text-body-sm-emphasis text-neutral-fg">
              {item.title}
            </span>
          ),
          children: (
            <p className="min-h-25 whitespace-pre-line text-justify text-body-sm text-gray-08">
              {item.description}
            </p>
          )
        }))}
      />
    </div>
  );
};

export default Faq;
